// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./page/Home";
import LawsuitDetail from "./page/LawsuitDetail";
import About from "./page/About";
import Contact from "./page/Contact";
import Blog from "./page/Blog";
import Newsletter from "./page/Newsletter";
import FAQs from "./page/FAQs";

import Privacy from "./page/Privacy";
import Terms from "./page/Terms";
import Partners from "./page/Partners";
// ⬇️ point to the file you actually have
import CaliforniaPrivacy from "./page/CaliforniaPrivacy1";
import Unsubscribe from "./page/Unsubscribe";
import DoNotSell from "./page/DoNotSell";

export default function App() {
  return (
    <>
      <Navbar />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/lawsuits/:slug" element={<LawsuitDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/faqs" element={<FAQs />} />

        {/* Footer links */}
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/california-privacy" element={<CaliforniaPrivacy />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        <Route path="/do-not-sell" element={<DoNotSell />} />

        <Route path="*" element={<NotFound />} />
      </Routes>

      <Footer />
    </>
  );
}

function NotFound() {
  return (
    <main style={{ padding: "64px 24px" }}>
      <h1>Not found</h1>
      <p>The page you’re looking for doesn’t exist.</p>
    </main>
  );
}
